/**
 * Assign config items from an array to the object items of another array.
 * @param items array of object to receive the config items.
 * @param configs array of either strings or objects to assign to the items.
 * @returns array of items with the randomly assigned configs.
 */
export function assignConfigToItems(items, configs) {
    return items.map((item, index) => {
        const config = configs[index % configs.length];
        return { ...item, config };
    });
}
